var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.row
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('transaction.tips.bill.amount'))
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayAmount)
    }
  })]), _c('div', {
    class: _vm.$style.row
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('transaction.tips.percent'))
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s("".concat(_vm.tips.percent, "%"))
    }
  })]), _c('div', {
    class: _vm.$style.row
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('transaction.tips.overall'))
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayOverall)
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }